var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    key: _vm.$route.params.id,
    ref: "MultiSearch",
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    staticStyle: {
      "flex-wrap": "wrap"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "btnsone"
    }
  }, [_c('el-dropdown', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("批量操作"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiArrangement($event)
      }
    }
  }, [_vm._v("批量面试安排")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiChangePosition(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改职位")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.syncToSupplier(_vm.idStr)
      }
    }
  }, [_vm._v("批量同步供应商")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改备注")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-mianshianpai",
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.myArrangement.show()
      }
    }
  }, [_vm._v("我的面试安排\n                    ")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "ml-10 mr-10"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr)
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, undefined, undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportParamsFiles('/employ/exportAllResume.api?employPhase=' + Number(_vm.$route.params.id - 1))
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(excel)\n                            ")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportParamsFiles('/employ/exportAllResume.api?employPhase=' + Number(_vm.$route.params.id - 1), 'HTML')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(html)\n                            ")])], 1)], 1), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_vm._v("导出面试评价")]) : _vm._e(), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "btnstwo"
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.resetInterview(_vm.idStr)
      }
    }
  }, [_vm._v("重置面试安排\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass')
      }
    }
  }, [_vm._v("通过\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'fq')
      }
    }
  }, [_vm._v("放弃\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'entry')
      }
    }
  }, [_vm._v("进入入职\n                        ")]), _vm._v(" "), (_vm.$store.state.user.paymentFlag) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": _vm.checkPaymentData
    }
  }, [_vm._v("进入定薪\n                        ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "fixed": "",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "align": "center",
      "fixed": "",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt eclip-name-txt",
          attrs: {
            "title": scope.row.resumeForm.name
          },
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                            ")]), _vm._v(" "), (scope.row.iaId > 0) ? _c('el-tag', {
          staticClass: "pull-right",
          attrs: {
            "type": "success",
            "title": "已安排面试"
          }
        }, [_vm._v("排\n                            ")]) : _vm._e()]
      }
    }], null, false, 1646321192)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.oldPositionName || scope.row.newPositionName) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.getPositionTipText(scope.row),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": scope.row.positionForm.name
          }
        }, [_vm._v(_vm._s(scope.row.positionForm.name))])]
      }
    }], null, false, 455889647)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.deptNames) + "\n                        ")]
      }
    }], null, false, 2934477005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "label": "邮箱",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.email || '-') + "\n                        ")]
      }
    }], null, false, 2903445021)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "最高学历",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n                        ")]
      }
    }], null, false, 433538694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.school",
      "label": "最高学历学校",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "show-overflow-tooltip": true,
      "label": "简历来源",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.transToText('WB_RESUME_SOURCE',
          scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 2622597149)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.residence || '-') + "\n                        ")]
      }
    }], null, false, 3375146197)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)) + "\n                        ")]
      }
    }], null, false, 2621839696)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n                        ")]
      }
    }], null, false, 3698601694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(scope.row)) + "\n                                ")])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 2141505024)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "同步供应商",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_SYNC_STATUS', scope.row.resumeForm.isSync)))])]
      }
    }], null, false, 3131267630)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          staticClass: "mr-5",
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("面试评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("通过\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/undetermined")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-daiding color-warning mr-10"
        }), _vm._v("待定\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("淘汰\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/lh")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-lahei color-purple mr-10"
        }), _vm._v("拉黑\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/fq")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("放弃\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/entry")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("进入入职\n                                    ")]), _vm._v(" "), (_vm.$store.state.user.paymentFlag && scope.row.positionForm.paymentState == 1) ? _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/payment")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("进入定薪\n                                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": _vm.getArrangementUrl(scope.row.id)
          }
        }, [_vm._v("面试安排")])]
      }
    }], null, false, 111580810)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('MyArrangementListDialog', {
    ref: "myArrangement"
  }), _vm._v(" "), _c('change-position-dialog', {
    ref: "changePositionDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa14abb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/interview/interviewList.vue
// module id = null
// module chunks = 